import { AnalyticsMetaKeys as key } from '../../../../../services/analytics/formatters/meta-keys'

export interface INavigationFormatter {
    format(attrs: string[], obj: any): object
}

export class NavigationFormatter implements INavigationFormatter {

    public format(attrs: string[], data: any): object {
        if (attrs.length < 1) {
            return {}
        }

        const fData: any = {}
        if (data.name) {
            fData[key.NAV_NAME] = data.name
        }
        if (data.loc) {
            fData[key.NAV_LOC] = data.loc
        }
        if (data.navClick) {
            fData[key.NAV_CLICK] = data.navClick
        }
        if (data) {
            attrs.forEach((attr) => {
                if (Object.keys(data).indexOf(attr) > -1) {
                    fData[attr] = String(data[attr])
                }
            })
        }
        return fData
    }
}
